import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import 'react-toastify/dist/ReactToastify.css';
import UserForm from './UserForm';

const UserFormPopup = ({
  subject = null,
  updateHandler = () => {},
  permissions = [],
  roles = [],
  user = null,
  brandId = null,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Button
        size="sm"
        color="info"
        onClick={toggle}
        className="d-flex align-items-center gap-1"
      >
        {user ? (
          <>
            <i className="bx bx-pen"></i> Edit
          </>
        ) : (
          <>
            <i className="bx bx-plus"></i>Create User
          </>
        )}
      </Button>

      <Modal
        size="lg"
        isOpen={isOpen}
        toggle={toggle}
        backdrop="static"
        className="modal-dialog-centered"
      >
        <ModalHeader toggle={toggle} className="border-bottom pb-3">
          {user ? 'Edit User' : 'Create New User'}
        </ModalHeader>
        <ModalBody>
          <UserForm
            handleClose={toggle}
            isFromPopup={true}
            subject={subject}
            updateHandler={updateHandler}
            permissions={permissions}
            roles={roles}
            user={user}
            brandId={brandId}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default UserFormPopup;
